import { render } from "./basket.vue?vue&type=template&id=7b721f8c&scoped=true"
import script from "./basket.vue?vue&type=script&lang=js"
export * from "./basket.vue?vue&type=script&lang=js"

import "./basket.vue?vue&type=style&index=0&id=7b721f8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b721f8c"]])

export default __exports__